import { useSelector } from "react-redux";
import numberWithCommas from "../utils/numberComma";

export default function Balance() {
  const { items } = useSelector((state) => state.item);
  const calculate = (items) => {
    let total = 0;
    console.log(total);
    console.log(items);
    items.forEach((item) => {
      const { type, amount } = item;
      if (type === "income") {
        total += amount;
      } else {
        total -= amount;
      }
    });

    console.log(total);
    return total;
  };

  return (
    <div className="top_card">
      <p>Your Current Balance</p>
      <h3>
        <span>৳</span>&nbsp;
        {items.length > 0 ? (
          <span>{numberWithCommas(calculate(items))}</span>
        ) : (
          <span>0</span>
        )}
      </h3>
    </div>
  );
}
